export default "__VITE_ASSET__B$$8ojcU__"